module.exports = __webpack_public_path__ + "img/purchase6.a4fd1515.png";